<template>
  <div class="feature-group" style="height: 65vh">
    <div class="create-form" v-show="assign_ftg_popup">
      <select v-model="assign_group" class="input is-small">
        <option
          :value="group"
          v-for="(group, i) of all_feature_type_groups"
          :key="i"
        >
          {{ group.name }}
        </option>
      </select>
      <div class="buttons are-small">
        <span @click="assign_ftg(assign_group.uid)" class="button is-danger"
          >{{localization('app-assign','Assign')}}</span
        >
        <span class="button cancel-btn" @click="assign_ftg_popup = false"
          >{{localization('app-cancel','Cancel')}}</span
        >
      </div>
    </div>
    <div
      style="
        text-align: left;
        margin-left: 0.8rem;
        font-size: 15px;
        margin-top: 0.3rem;
        font-weight: 500;
      "
      class="create-form"
      v-if="$store.getters.has_modify_feautes_type_permissions"
    >
      <a
        v-if="!assign_ftg_popup && !is_create && !is_edit"
        class="has-text-left is-semibold-16-600-19 has-text-info btn is-small"
      >
        <span @click="$root.$emit('create_modal')">
          <span class="icon">
            <i class="fa fa-edit"></i>
          </span>
          {{localization("app-create-modify-feature-types", "Create / Modify feature types")}}
        </span>
        <!-- <span title="Create or Assign Feature Type Group">
          <a @click="toggle()">Create</a> or
          <a @click="assign_ftg_popup=true">Assign</a>
          GROUP
          <a
            class="has-text-info"
            style="margin-left:2rem"
            @click="edit_mode=!edit_mode"
            :class="{'has-text-success':edit_mode}"
          >
            <i class="fa fa-edit"></i>
          </a>
        </span>-->
      </a>
      <div v-if="is_create || is_edit" class="field" style="position: relative">
        <div class="color-input">
          <input
            v-model="form.name"
            @keyup.enter="save()"
            class="input is-small"
            ref="name"
            autofocus
            :placeholder="localization('app-name','Name')"
          />
        </div>
        <div class="buttons are-small">
          <span class="button is-danger" @click="save()">{{localization('app-create','Create')}}</span>
          <span
            class="button cancel-btn"
            @click="
              is_create = false;
              is_edit = false;
              form.name = '';
            "
            >{{localization('app-cancel','Cancel')}}</span
          >
        </div>
      </div>
    </div>
    <smooth-scrollbar v-if="feature_type_groups">
      <div style="height: 80vh">
        <feature-type-group
          @on_add_feature_type="get_feature_type_groups"
          v-for="(feature_type_group, index) in sort(feature_type_groups)"
          :key="index"
          :feature_type_group="feature_type_group"
          @onDeleteFeature="get_feature_type_groups"
          @edit="onEdit($event)"
          :edit_mode.sync="edit_mode"
        ></feature-type-group>
        <!-- projects props issue-types sum -->
       <project-props></project-props>
        <!-- projects props issue-types sum -->
      </div>
    </smooth-scrollbar>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import FeatureTypeGroup from "./feature-type-group.component";
import FeatureTypeGroupService from "@/services/feature-type-group.service";
import _ from "lodash";
import ProjectProps  from "./project-props";

export default {
  components: {
    FeatureTypeGroup,
    ProjectProps
  },
  data() {
    return {
      edit_mode: false,

      all_feature_type_groups: null,
      assign_ftg_popup: false,
      is_create: false,
      is_edit: false,
      featureTypeGroupService: new FeatureTypeGroupService(),
      form: {
        name: "",
      },
      assign_group: null,
    };
  },
  created() {
    this.$root.$on("update_feature_type", this.get_feature_type_groups);
  },
  watch: {
    container: function (val) {
      if (val) {
        this.get_all_feature_type_groups();
      }
    },
  },
  computed: {
    ...mapState(["feature_type_groups", "features_count", "container"]),
  },
  methods: {
    ...mapMutations([
      "SET_FEATURE_TYPE_GROUPS",
      "INIT_FEATURE_COLORS",
      // "SET_FEATURE_TYPE_FILTERS"
    ]),
    sort(data) {
      if (data && data.length) return _.sortBy(data, ["name"]);
      return [];
    },
    get_feature_type_groups() {
      this.featureTypeGroupService
        .getAll({
          query: `pk=true&${this.$store.state.route_name}=${this.$route.params.uid}`,
        })
        .then((res) => {
          this.SET_FEATURE_TYPE_GROUPS(res.data);
          this.INIT_FEATURE_COLORS();
        });
    },
    toggle() {
      this.is_create = !this.is_create;
    },
    onEdit(ftg) {
      this.is_edit = true;
      this.form = Object.assign({}, ftg);
    },
    save() {
      if (!this.form.name) {
        this.$toast.open("Name is Required");
        return;
      }

      if (this.is_edit) {
        this.is_edit = false;
        this.featureTypeGroupService
          .patch({
            uid: this.form.uid,
            body: {
              name: this.form.name,
            },
          })
          .then((res) => {
            this.form.name = "";
            this.get_feature_type_groups();
          });
      } else if (this.is_create) {
        this.is_create = false;
        this.featureTypeGroupService
          .post({
            body: { name: this.form.name, org: this.container.organization },
          })
          .then((res) => {
            this.form.name = "";
            this.assign_ftg(res.data.uid);
          });
      }
    },
    assign_ftg(uid) {
      this.featureTypeGroupService
        .assign_to_container({
          id: this.$route.params.uid,
          body: {
            featureTypeGroup: uid,
          },
        })
        .then((res) => {
          this.assign_ftg_popup = false;
          this.get_feature_type_groups();
        })
        .catch((err) => {
          this.handleErrors(err);
          console.log("err");
        });
    },
    get_all_feature_type_groups() {
      this.featureTypeGroupService
        .getAll({
          query: `pk=true&exclude_${this.$store.state.route_name}s=${this.$route.params.uid}&org=${this.container.organization}`,
        })
        .then((res) => {
          this.all_feature_type_groups = res.data;
          let filter_keys = [];
          this.all_feature_type_groups.forEach((g) => {
            g.featureTypes.forEach((f) => {
              filter_keys.push(f.id);
            });
          });
          // this.SET_FEATURE_TYPE_FILTERS(filter_keys);
        });
    },
  },
};
</script>

<style lang="scss">
.create-form {
  margin-bottom: 0.5rem;
  padding: 0 9px;
  .has-text-info {
    color: #2585d3 !important;
    &:hover {
      @extend .has-text-info;
    }
  }
  .btn {
    border: 0;
  }
  .color-list {
    z-index: 100;
    background: white;
    position: absolute;
    width: 150px;
    height: 140px;
    left: 0;
    top: 2rem;
    bottom: 1rem;
    border: 1px solid #ccc;
    .fas {
      cursor: pointer;
      margin: 0.5rem;
    }
  }
  .input:focus,
  .input:active,
  .input.is-active {
    border-color: #ccc;
    box-shadow: none;
  }
  .buttons {
    margin-top: 0.5rem;
    .cancel-btn {
      border: none;
    }
  }
  .color-input {
    display: flex;
    align-items: center;
    border: 1px solid grey;
    .icon {
      margin: 0 8px;
    }
    .input {
      box-shadow: none;
      border: none;
    }
  }
}
</style>


